export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12593.9c149148.jpg";